var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionEyeOffOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.65 17.3l-3.2-3.3-3.9-3.9-1.6-1.5L3.35 2l-1.4 1.4 3.37 3.37C2.594 9.08 1 12 1 12s4.373 8 11 8c1.863 0 3.549-.632 5.008-1.542L20.65 22.1l1.4-1.4-3.4-3.4zm-3.101-.301C14.446 17.616 13.253 18 12 18c-2.499 0-4.757-1.527-6.543-3.386A19.762 19.762 0 013.355 12a19.893 19.893 0 012.102-2.614c.404-.42.832-.824 1.282-1.197L9.28 10.73a3 3 0 003.987 3.987l2.28 2.28z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12s-1.055 1.93-2.915 3.895l-1.393-1.437A19.89 19.89 0 0020.645 12l-.082-.12a19.777 19.777 0 00-2.02-2.494C16.757 7.527 14.5 6 12 6c-.559 0-1.105.076-1.637.216L8.78 4.633A8.722 8.722 0 0112 4c6.627 0 11 8 11 8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionEyeOffOutline);
export default __webpack_public_path__ + "b1933efb69a00047232e1dbc8bb409eb.svg";
export { ForwardRef as ReactComponent };